import React from "react";

const Container = (props) => {
    const {
        name,
        children,
        wrapperClassNames,
        wrapperStyle,
        contentClassNames,
        contentStyle,
    } = props;

    return (
        <div
            id={name ? `${name}-wrapper` : undefined}
            style={wrapperStyle ? wrapperStyle : undefined}
            className={`container-wrapper${
                wrapperClassNames ? ` ${wrapperClassNames}` : ""
            }`}
            onMouseLeave={props.onMouseLeave}
            onMouseOver={props.onMouseOver}
        >
            <div
                id={name ? `${name}-content` : undefined}
                style={contentStyle}
                className={`container-content${
                    contentClassNames ? ` ${contentClassNames}` : ""
                }`}
            >
                {children}
            </div>
        </div>
    );
};

export default Container;
